var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.829 14.829 5.656-5.657.707.707 1.415-1.415-7.071-7.07-1.415 1.414.707.707-5.656 5.657H6.343L4.93 10.586l3.677 3.677-4.243 4.242 1.132 1.132 4.242-4.243 3.677 3.677 1.415-1.414v-2.829z"
})));
export default SvgPin;